// paymentRefundSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_payment_refund_list = createAsyncThunk(
  "paymentRefund/list",
  async (data) => {
    const body = new FormData();
    body.append("action", "list");
    body.append("page", data.page.toString());
    body.append("limit", data.rows.toString());
    
    const response = await fetch(baseUrl + "payment_refund.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);

const initialState = {
  payment_refund_list: [],
  total_refund_count: 0,
  loading: false,
};

const paymentRefundSlice = createSlice({
  name: "paymentRefund",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_payment_refund_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_payment_refund_list.rejected, (state) => {
        state.loading = false;
      })
      .addCase(get_payment_refund_list.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          state.payment_refund_list = data.data;
          state.total_refund_count = parseInt(data.totalcount) || 0;
        } else {
          state.payment_refund_list = [];
          state.total_refund_count = 0;
        }
      });
  },
});

export default paymentRefundSlice.reducer;